import React from "react";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface VerifikasiEmailPageLayoutProps {
    children: React.ReactNode;
}

const VerifikasiEmailPageLayout = ({
    children,
}: VerifikasiEmailPageLayoutProps) => {
    const theme = useTheme();
    const isTabletScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box
            sx={{
                width: isTabletScreen ? "100%" : undefined,
                height: isTabletScreen ? "100%" : undefined,
                display: "flex",
                flexDirection: "column",
                gap: 6,
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#FFF",
                borderRadius: 1,
                padding: isTabletScreen ? 3 : 9,
            }}
        >
            {children}
        </Box>
    );
};

export default VerifikasiEmailPageLayout;
